'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Icon = require('../../../icon/jsx/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // React component based on pp-vx design
// https://github.paypal.com/pages/PayPal-UI-R/VX/#radio


function RadioGroup(props) {
  var className = props.className,
      error = props.error,
      helper = props.helper,
      icon = props.icon,
      id = props.id,
      isValid = props.isValid,
      label = props.label,
      name = props.name,
      options = props.options,
      value = props.value,
      rest = _objectWithoutProperties(props, ['className', 'error', 'helper', 'icon', 'id', 'isValid', 'label', 'name', 'options', 'value']);

  var baseClass = 'ppvx_radio';

  var wrapperClassNames = (0, _classnames2.default)(className, baseClass + '-group', {
    'ppvx_field--error': !isValid
  });

  return _react2.default.createElement(
    'div',
    { className: wrapperClassNames },
    label && _react2.default.createElement(
      'label',
      { htmlFor: id, className: baseClass + '-group__label' },
      label.text,
      icon && _react2.default.createElement(_Icon2.default, { name: icon.name, size: 'xs', title: icon.title })
    ),
    options.map(function (option, i) {
      return _react2.default.createElement(
        'div',
        { key: name + '_' + i },
        _react2.default.createElement(
          'div',
          { className: baseClass },
          _react2.default.createElement('input', _extends({
            className: baseClass + '__input',
            type: 'radio',
            name: name,
            id: id + '_' + i,
            value: option.value,
            checked: value === option.value ? 'checked' : null
          }, rest)),
          _react2.default.createElement(
            'label',
            { className: baseClass + '__label', htmlFor: id + '_' + i },
            option.label.text,
            option.icon && _react2.default.createElement(_Icon2.default, { name: option.icon.name, size: 'xs', title: option.icon.title })
          )
        ),
        option.helper && _react2.default.createElement(
          'div',
          { className: baseClass + '__helper-text' },
          option.helper.text
        )
      );
    }),
    !isValid && error ? _react2.default.createElement(
      'div',
      { className: baseClass + '-group__error-text' },
      error.text
    ) : helper && _react2.default.createElement(
      'div',
      { className: baseClass + '-group__helper-text' },
      helper.text
    )
  );
}

RadioGroup.propTypes = {
  className: _propTypes2.default.string,
  error: _propTypes2.default.shape({
    text: _propTypes2.default.string.isRequired
  }),
  helper: _propTypes2.default.shape({
    text: _propTypes2.default.string.isRequired
  }),
  icon: _propTypes2.default.shape({
    name: _propTypes2.default.string.isRequired,
    title: _propTypes2.default.string.isRequired
  }),
  id: _propTypes2.default.string.isRequired,
  isValid: _propTypes2.default.bool,
  label: _propTypes2.default.shape({
    text: _propTypes2.default.string.isRequired
  }),
  name: _propTypes2.default.string.isRequired,
  options: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.shape({
    label: _propTypes2.default.shape({
      text: _propTypes2.default.oneOf([_propTypes2.default.string, _propTypes2.default.number])
    }).isRequired,
    value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number] // could be an array index
    ).isRequired,
    icon: _propTypes2.default.shape({
      name: _propTypes2.default.string.isRequired,
      title: _propTypes2.default.string.isRequired
    })
  })]).isRequired).isRequired,
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number] // could be an array index
  )
};

RadioGroup.defaultProps = {
  className: '',
  error: {
    text: 'Please select an option' // overrides helper text when isValid is false
  },
  helper: {
    text: 'Pick your top option' // helper text that appears below the input
  },
  icon: {
    name: 'ppvx_icon-bank',
    title: 'Location'
  },
  isValid: true, // must be false for error message to show
  label: {
    text: 'Select the country you most want to go to'
  },
  value: ''
};

exports.default = RadioGroup;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/atoms/forms/radio-group/jsx/RadioGroup.js
// module id = 1065
// module chunks = 4